import React from 'react';
import axios from 'axios';
import {Dropdown} from 'semantic-ui-react';
import { prepareDataForValidation } from 'formik';
import GroupChart from './Charts/GroupChart';
import PieChart from './Charts/PieChart';
import StackChart from './Charts/StackChart';

export default class PerkCategoryBudgetReport extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            allTeam : props.allTeam,
            teamList : props.team,
            allEmployee : props.allEmployee,
            employeeList : props.employee,
            perkCategories : [],
            categories: [],
            selected: false,
            selectedCategories: [],
            chartType: 1,
            accessToken: localStorage.getItem('accessToken'),
            groupChartData: null,
            stackChartData: null,
            pieChartData: null,
            dropdownOptions : [],
            url: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080',
            description: []
        }
    }

    countOccurrences = arr => arr.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {});

    getPerkPrograms = async () => {
        await axios.post(this.state.url + "/perks-program/get-all", {}, {
            headers: {'Authorization': `Bearer ${this.state.accessToken}`}
        }).then(async response => {
            console.log(response);
            if(response.status === 200){
                if(response.data && response.data.data){
                    const perksPrograms = response.data.data;
                    const currentDate = new Date();
                    const programs = perksPrograms.map(program => {
                        const {id, name, startDate, endDate, frequency, perks} = program;
                        const startDateObj = new Date(startDate);
                        const endDateObj = endDate ? new Date(endDate) : null;
                        const active = endDate ? endDateObj.getTime() >= currentDate.getTime() : true;
                        return {id, name, startDate: startDateObj, endDate: endDateObj, frequency, active, perks};
                    });
                    await axios.get(this.state.url + '/perks/get-all', {}, {
                        headers: {'Authorization': `Bearer ${this.state.accessToken}`}
                    }).then(response => {
                        if(response.status === 200){
                            if(response.data && response.data.data && programs.length>0){
                                const perks = response.data.data;
                                
                                const perkProgramFound = []
                                const perksFound = []
                                const categoriesFound = []
                                this.state.teamList.forEach(team => {
                                    programs.forEach(program => {
                                        if(team.perksProgramId === program.id && program.active){
                                            const numEmployees = this.state.employeeList.filter(emp => {return emp.teamId === team._id}).length
                                            perkProgramFound.push({teamId: team._id, budget: team.budget * numEmployees, name:team.name, perksId: program.perks})
                                        }
                                    })
                                })
                                const perkCategoriesFound = []
                                var tempObject = []
                                perkProgramFound.forEach(team => {
                                    const temp = []
                                    team.perksId.forEach(perkId => {
                                        perks.forEach(perk => {
                                            if(perk.id === perkId._id){
                                                temp.push(perk.categories.map(cat => {return cat.toLowerCase()}));
                                                perk.categories.forEach(category => {
                                                    if(!perkCategoriesFound.includes(category.toLowerCase())){
                                                        perkCategoriesFound.push(category.toLowerCase())
                                                    }
                                                })
                                            }
                                        })
                                    })
                                    perksFound.push({teamId: team.teamId, budget:team.budget, name:team.name, categories: temp.flat(3)});
                                })
                                perkCategoriesFound.forEach((category, index) => {
                                    tempObject.push({key: index, text: category, value: category})
                                })
                                perksFound.forEach(team => {
                                    categoriesFound.push({_id: team.teamId, budget:team.budget, name:team.name, categoriesDic: this.countOccurrences(team.categories)});
                                })
                                // var keys;
                                var catSum;
                                var finalCategories = []
                                var dataForDes = []
                                categoriesFound.forEach(team => {
                                    catSum = Object.keys(team.categoriesDic).reduce((sum,key)=>sum+parseFloat(team.categoriesDic[key]||0),0)
                                    var total = 0;
                                    for(const key in team.categoriesDic){
                                        var budget = parseFloat(((team.categoriesDic[key] * team.budget) / catSum).toFixed(2));
                                        team.categoriesDic[key] = budget
                                        total += budget;
                                    }
                                    finalCategories.push({team: team.name, budget: total, categories: team.categoriesDic})
                                    dataForDes.push(`Total Budget for ${team.name}: $${Math.round(total)}`)
                                })
                                this.setState({description: dataForDes})
                                finalCategories.sort(function(a,b) {
                                    return b.budget - a.budget
                                })
                                console. log(finalCategories)
                                console.log(perkCategoriesFound)
                                this.setState({perkCategories: finalCategories}); // This is the entire object mapping team names to perk categories and budget
                                this.setState({selectedCategories: perkCategoriesFound}); 
                                // this.setState({categories: perkCategoriesFound}); // This is the list of Perk Categories in all the teams combined
                                this.setState({dropdownOptions: tempObject})
                                this.prepareData(perkCategoriesFound, finalCategories);
                            }
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }
            }
        }).catch(error => {
            console.log(error)
        })
    }
    
    componentDidMount() {
        this.getPerkPrograms();
        // this.drawChart();
    }

    prepareData(selectedCategories, finalCategories) {
        var groupDat = []
        var groupColumns = ["Team"]
        var stackColumn = "name"
        var stackData = "\r"
        var pieTeamChildren = []
        selectedCategories.sort().forEach(category => {
            groupColumns.push(category);
            stackColumn += ","+category
        })
        finalCategories.forEach(team => {
            var groupObj = {Team: team.team}
            var pieTeamObj = {name: team.team}
            var pieCategoryList = []
            stackData += team.team
            selectedCategories.forEach(category => {
                if(!(Object.keys(team.categories)).includes(category)){
                    team.categories[category] = 0
                }
            })
            Object.keys(team.categories).sort().forEach(key => {
                if(selectedCategories.includes(key)){
                    groupObj[key] = team.categories[key]
                    // groupColumns.push(key)
                    pieCategoryList.push({
                        name: key,
                        value: team.categories[key]
                    })
                    // stackColumn += ","+key
                    stackData += ","+String(team.categories[key])
                }
            })

            groupDat.push(groupObj);
            pieTeamObj['children'] = pieCategoryList;
            pieTeamChildren.push(pieTeamObj)
            stackData += "\r"
        })
        var group = {
            dat: groupDat,
            columns: groupColumns,
            y: "Average Budget"
        }
        var stack = stackColumn + stackData
        var pie = {
            name: "organization",
            children: pieTeamChildren
        }
        this.setState({groupChartData:group})
        this.setState({stackChartData:stack})
        this.setState({pieChartData:pie})
        console.log(group)
        console.log(stack)
        console.log(pie)
        this.setState({selected: true})
    }

    chartTypeChanged(event, value) {
        this.setState({selected: false})
        this.setState({chartType: value.value})
        this.setState({selected: true})
    }

    categoriesChanged(event, value) {
        this.setState({selected: false})
        var cats = []
        value.value.forEach(selection => {
            cats.push(selection)
        })
        // this.setState({selectedCategories: cats})
        console.log(cats)
        if(cats.length === 0){
            this.prepareData(this.state.selectedCategories, this.state.perkCategories)
        }else{
            this.prepareData(cats, this.state.perkCategories)
        }
        
        this.setState({selected: true})
    }

    render() {
        return (
            <div style={{flex:1, flexDirection: 'column'}}>
                <div style={{flex:1, flexDirection:'row', padding:10}}>
                            <span style={{flex:1}}>Select Chart type:</span>
                            <span style={{flex:3, paddingLeft:20}}>
                                < Dropdown
                                placeholder= 'Select Chart Type'
                                name = 'Select Chart Type'
                                search
                                closeOnChange
                                defaultValue={1}
                                style={{width: '30%', fontFamily: 'SFProText-Regular'}}
                                // inline
                                selection
                                options={[{key: 1, text: 'Grouped Bar Chart (Team/Category Perk Budget)', value: 1},
                                        {key: 2, text: 'Pie Chart (Team/Category Perk Budget)', value: 2},
                                        {key: 3, text: 'Stacked Chart (Team/Category Perk Budget)', value: 3},
                                        ]}
                                onChange = {(e, value) => this.chartTypeChanged(e, value)} 
                            />
                            </span>
                            <span style={{flex:1, paddingLeft: 20}}>Select Categories:</span>
                            <span style={{flex:3, paddingLeft:20}}>
                                < Dropdown
                                    placeholder= 'Select Categories'
                                    name = 'Select Categories'
                                    search
                                    defaultValue={1}
                                    style={{width: '30%', fontFamily: 'SFProText-Regular'}}
                                    multiple
                                    selection
                                    options={this.state.dropdownOptions}
                                    onChange = {(e, value) => this.categoriesChanged(e, value)} 
                                />
                            </span>
                </div>

                {this.state.selected && this.state.selectedCategories ? 
                    <div>
                        <div ref = {this.pdfRef}>
                            {(this.state.chartType === 1 && this.state.groupChartData) ?
                                <GroupChart data={this.state.groupChartData} title={"Perk Budget Allocation per Team/Category"} description={this.state.description} />
                            :
                                (this.state.chartType === 2 && this.state.pieChartData) ?
                                    <PieChart data={this.state.pieChartData} title={"Perk Budget Allocation per Team/Category"} description={this.state.description} />
                                :
                                    (this.state.chartType === 3 && this.state.stackChartData) ?
                                        <StackChart data={this.state.stackChartData} title={"Perk Budget Allocation per Team/Category"} description={this.state.description} />
                                    :
                                        null
                            }
                        </div>
                    </div>
                :
                    <div>No Data to Display</div>
                }
            </div>
        )
    }
}
